/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text, TextProps } from '@mantine/core';
import { FC } from 'react';

const EmptyText: FC<TextProps> = ({ ...props }) => (
  <Text italic color="dimmed" size="xs" weight="lighter" {...props}>
    Noch nichts hinzugefügt.
  </Text>
);

export default EmptyText;
